export default "__VITE_ASSET__B0yggdvb__"